import { defineComponent as _defineComponent } from 'vue'
import VueMarkdown from 'vue-markdown-render'
import hljs from 'highlight.js'
import { useRedirectModal } from '@/components/redirect/useRedirectModal'


export default /*#__PURE__*/_defineComponent({
  __name: 'Markdown',
  props: {
    source: null
  },
  setup(__props: any) {



useRedirectModal('.content-markdown')

const highlightOptions = {
  html: true,
  linkify: true,
  typographer: true,
  highlight: (code: string, lang: string) => {
    if (lang && hljs.getLanguage(lang)) {
      try {
        return (
          '<pre class="hljs"><code>' +
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          hljs.highlight(code, { language: lang } as any).value +
          '</code></pre>'
        )
      } catch (__) {
        return ''
      }
    }
    return hljs.highlightAuto(code).value
  },
}

return { __sfc: true,highlightOptions, VueMarkdown }
}

})